import { render, staticRenderFns } from "./InputPrezzo.vue?vue&type=template&id=5ae87fdb&scoped=true&"
import script from "./InputPrezzo.vue?vue&type=script&lang=js&"
export * from "./InputPrezzo.vue?vue&type=script&lang=js&"
import style0 from "./InputPrezzo.vue?vue&type=style&index=0&id=5ae87fdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae87fdb",
  null
  
)

export default component.exports